import { Typography } from "@material-ui/core";
import React from "react";
export function TourGeneralInfo({ description }) {
    const paragraphs = [description.description]; //.split(/[\r\n]+/);
    return React.createElement("div", null, paragraphs.map((x, i) => React.createElement(Typography, { variant: "body1", paragraph: i < paragraphs.length - 1, key: i },
        React.createElement("div", { dangerouslySetInnerHTML: { __html: x } }))));
}
